import { Link } from "react-router-dom";
import { useAppSelector } from "@/redux/hooks/hooks";
import { useGetMeQuery } from "@/redux/feature/user/userApi";

import NotificationIcon from "@/assets/icons/Notification.svg";
import MessageIcon from "@/assets/icons/Messages.svg";
import UserDropDown from "../../ui/UserDropDown";
import MobileHeader from "./mobileHeader";
import { TUser, UserDetails } from "@/types/types";

const Header = () => {
  // const { userAvailableRevisions } = useAppSelector((state) => state.global);
  const { user } = useAppSelector((state) => state.auth);
  const { data } = useGetMeQuery(user?.email);
  const userData: TUser | undefined = data?.data;
  const name = userData?.fullName || "User";
 
  return (
    <div className="flex border-b border-[#DFDFDF] justify-between py-4 px-4 md:pl-12 md:pr-6">
      <DesktopHeader name={name}  userData={userData} />
      <MobileHeader />
    </div>
  );
};

// Desktop header
interface DesktopHeaderProps {
  name: string;
  userData: TUser | undefined;
}

const DesktopHeader = ({ name, userData,  }: DesktopHeaderProps) => (
  <div className="hidden md:flex items-center justify-between w-full">
    <div>
      <div className="flex gap-2 items-center">
        <h2 className="text-body-medium font-medium text-[#101828]">
          Welcome, {name}
        </h2>
        <p className="text-[#6941C6] text-xs font-medium leading-[18px] py-[2px] px-2 rounded-2xl bg-[#F9F5FF]">
          Independent Creator
        </p>
      </div>
      <p className="text-caption-large text-gray-500 mt-1">
        Easily create and manage orders here.
      </p>
    </div>
    <div className="flex items-center gap-x-4">
      {/* <Link to={"/notification"}>
        <MessageIcon />
      </Link> */}
      <Link to={"/notification"}>
        <NotificationIcon />
      </Link>
      <UserDropDown />
    </div>
  </div>
);

export default Header;
